import React from "react";
import styled from "styled-components";
import { Link } from "../../Link";
import { HelpIcon } from "../../Svg";
import { Modal } from "../ModalUI";
import WalletCard from "./WalletCard";
import config from "./config";
import { Login } from "./types";

interface Props {
  login: Login;
  onDismiss?: () => void;
}

const HelpLink = styled(Link)`
  display: flex;
  align-self: center;
  align-items: center;
  margin-top: 24px;
`;

const ConnectModal: React.FC<Props> = ({ login, onDismiss = () => null }) => (
  <Modal title="Connect to a wallet" onDismiss={onDismiss}>
    {config.map((entry, index) => (
      <WalletCard
        key={entry.title}
        login={login}
        walletConfig={entry}
        onDismiss={onDismiss}
        mb={index < config.length - 1 ? "8px" : "0"}
      />
    ))}
    <HelpLink
      href="https://docs.pancakeswap.finance/get-started/connection-guide"
      external
    >
      <HelpIcon color="primary" style={{ marginRight: "6px" }} />
      Learn how to connect
    </HelpLink>
  </Modal>
);

export default ConnectModal;
